import { Theme, styled, useMediaQuery } from '@mui/material';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Footer } from 'src/components/molecules/footer';
import { Navbar } from 'src/components/organisms/navbar';
import { Sidebar } from 'src/components/organisms/sidebar';
import { useSettingsStore } from 'src/store/settings-store';
import bg from '/static/bg.png';

const LayoutRoot = styled('div')(() => ({
  backgroundImage: `url(${bg})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed',
  minHeight: '100%',
  paddingTop: 64,
}));

export const Layout: FC = () => {
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const settingsPinSidebar = useSettingsStore(state => state.pinSidebar);

  const LayoutContent = styled('div')(({ theme }: { theme: Theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    [theme.breakpoints.up('md')]: {
      marginLeft: settingsPinSidebar ? '270px' : '73px',
    },
  }));

  return (
    <LayoutRoot>
      <Navbar />
      {!mdDown ? <Sidebar pinned={settingsPinSidebar} /> : null}
      <LayoutContent
        sx={{
          minHeight: `calc(100vh - 64px)`,
          ml: {
            md: settingsPinSidebar ? '270px' : '73px',
          },
        }}>
        <Outlet />
        <Footer />
      </LayoutContent>
    </LayoutRoot>
  );
};
